import Header from "../Components/Header";
import Footer from "../Components/Footer";

export default function CommonLanding({
  title,
  subtitle,
  heading,
  text,
  image,
  features,
  ctaText,
  schema
}) {
  return (
    <>
      <Header />

      {/* ✅ JSON-LD SCHEMA */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />

      <section className="ib-bday-wrapper">

        {/* HERO */}
        <div className="ib-bday-hero">
          <div className="ib-bday-container">
            <h1 className="ib-bday-title">{title}</h1>

            {/* CTA under H1 */}
            <a href="/contact" className="ib-bday-btn">
              {ctaText}
            </a>

            <p className="ib-bday-subtitle">{subtitle}</p>
          </div>
        </div>

        {/* INTRO */}
        <div className="ib-bday-section">
          <div className="ib-bday-container ib-bday-grid">

            <div className="ib-bday-content">
              <h2 className="ib-bday-heading">{heading}</h2>

              <p className="ib-bday-text">
                <b>{text}</b>
              </p>
            </div>

            <div className="ib-bday-image">
              <img src={image} alt={title} />
            </div>

          </div>
        </div>

        {/* FEATURES */}
        <div className="ib-bday-features">
          <div className="ib-bday-container">

            <h2 className="ib-bday-heading-center">
              What You Get
            </h2>

            <div className="ib-bday-feature-grid">
              {features.map((item, index) => (
                <div key={index} className="ib-bday-card">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>

          </div>
        </div>

        {/* CTA */}
        <div className="ib-bday-cta">
          <div className="ib-bday-container ib-bday-cta-inner">
            <a href="/contact" className="ib-bday-btn">
              {ctaText}
            </a>
          </div>
        </div>

      </section>

      <Footer />
    </>
  );
}
